import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import { connect } from 'react-redux';
import moment from 'moment';
import { TextMessage } from 'components/tt-forms/common';
import TextTruncate from 'react-text-truncate';
import {CheckPermission} from 'modules/login/CheckPermission';
import { ShowIf } from 'components/utils';

class RowItemReception extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      enableAddmore: true,
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
    }
  }

  componentDidMount() {
    let LetterInfor = this.props.item;
    if (LetterInfor.donSTCD.hoanThanhDon || LetterInfor.donSTCD.thanhLapTiepDanGapLanhDao || LetterInfor.hoanThanhTCDThuongXuyen) {
      this.setState({
        enableAddmore: false
      })
    } else {
      this.setState({
        enableAddmore: true
      })
    }

    if (this.props.item.donSTCD.trangThaiDonInfo) {
      this.props.item.donSTCD.trangThaiDonInfo.filter(item => {
        return item.donViId == this.props.userInfo.donViId;
      }).map((child, i) => {
        if (this.props.item.ma && child.ketQuaType == 'DINH_CHI') {
          this.setState({
            ketQuaStr: 'Đình chỉ',
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        } else if (!this.props.item.ma && child.ketQuaType == 'DINH_CHI') {
          this.setState({
            ketQuaStr: 'Rút đơn',
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        } else {
          this.setState({
            ketQuaStr: child.ketQuaStr,
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        }
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    let LetterInfor = nextProps.item;
    if (LetterInfor.donSTCD.hoanThanhDon || LetterInfor.donSTCD.thanhLapTiepDanGapLanhDao || LetterInfor.hoanThanhTCDThuongXuyen) {
      this.setState({
        enableAddmore: false
      })
    } else {
      this.setState({
        enableAddmore: true
      })
    }
  };

  getLocal(data) {
    let address = [];
    if(data) {
      if(data.diaChi) {
        address.push(data.diaChi);
      }
      if(data.toThon) {
        address.push(data.toThon);
      }
      if(data.phuongXaCongDan && data.phuongXaCongDan.ten) {
        address.push(data.phuongXaCongDan.ten);
      }
      if(data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
        address.push(data.quanHuyenCongDan.ten);
      }
      if(data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
        address.push(data.tinhThanhCongDan.ten);
      }
    }
    return address.join(", ");
  }

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.ngayTiepDan ? moment(this.props.item.ngayTiepDan).format('DD/MM/YYYY') : ''}</li>
            <li>{this.props.item.ngayTiepDan ? moment(this.props.item.ngayTiepDan).format('HH:mm') : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li className="txt-bold">{this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].hoVaTen : ''}</li>
            <li>{this.getLocal(this.props.item.donSTCD.listNguoiDungDon[0])}</li>
            <li>{this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].soDienThoai : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              <Link className="txt-underline txt-regular" to={`/tiep-cong-dan/chi-tiet-don/${this.props.item.soTiepCongDanId}`}>
                 <TextTruncate
                   line={3}
                   truncateText="…"
                   text={this.props.item.donSTCD.noiDung}
                 />
              </Link>
            </li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
             {this.props.item.donSTCD.loaiDonInfo ? this.props.item.donSTCD.loaiDonInfo.ten : ''}
            </li>
            <li>{this.props.item.donSTCD.soNguoi} Người</li>
          </ul>
        </td>
        <td>{this.props.item.donSTCD.coQuanDaGiaiQuyetDonThu || ''}</td>
        <td>
          {this.props.item.canBoTiepDanInfo.hoVaTen}
        </td>
        <td>{this.props.item.soLuotTiepStr}</td>
        <td>
          {this.props.item.huongXuLyText || ''}
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.state.trangThaiDonText}</li>
            <li>
              <TextMessage className='txt-italic col-100 no-gutter txt-left' value={this.state.ketQuaStr || ''}/>
            </li>
          </ul>
        </td>
        <td>
          {
            this.props.userInfo.id === this.props.item.nguoiTaoId ? (
              <div className="todo-wrap two-item">
                <ShowIf condition={(CheckPermission('SOTIEPCONGDAN_THEM') && !this.props.item.donSTCD.thanhLapTiepDanGapLanhDao && !this.props.item.hoanThanhTCDThuongXuyen) && this.state.enableAddmore && this.props.item.donSTCD.tongSoLuotTCD == this.props.item.soThuTuLuotTiep && !this.props.item.donSTCD.lanhDaoDuyet && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'DONG_Y' && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'KHONG_DONG_Y' }>
                  <div className="wrap-link-todo">
                    <Link className="itt-add" to={`/tiep-cong-dan/thuong-xuyen/them-luot/${this.props.item.soTiepCongDanId}`}>Thêm Lượt</Link>
                  </div>
                </ShowIf>

                <ShowIf condition={(CheckPermission('SOTIEPCONGDAN_SUA') && !this.props.item.donSTCD.thanhLapTiepDanGapLanhDao && !this.props.item.hoanThanhTCDThuongXuyen) && this.state.enableAddmore && this.props.item.donSTCD.tongSoLuotTCD == this.props.item.soThuTuLuotTiep && !this.props.item.donSTCD.lanhDaoDuyet && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'DONG_Y' && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'KHONG_DONG_Y'}>
                  <div className="wrap-link-todo">
                    <Link className="itt-edit" to={`/tiep-cong-dan/thuong-xuyen/chinh-sua/${this.props.item.soTiepCongDanId}`}>Chỉnh sửa</Link>
                  </div>
                </ShowIf>

                <ShowIf condition={CheckPermission('SOTIEPCONGDAN_XOA') && !this.props.item.donSTCD.thanhLapTiepDanGapLanhDao && !this.props.item.hoanThanhTCDThuongXuyen && this.props.item.donSTCD.tongSoLuotTCD == this.props.item.soThuTuLuotTiep && !this.props.item.donSTCD.hoanThanhDon && !this.props.item.donSTCD.lanhDaoDuyet && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'DONG_Y' && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'KHONG_DONG_Y' && !this.props.item.donSTCD.thanhLapDon}>
                  <DeleteDialog
                    title={'Xác nhận'}
                    content={`Bạn có đồng ý xóa thông tin về lượt tiếp ${this.props.item.donSTCD.listNguoiDungDon.length ? ('công dân "'+this.props.item.donSTCD.listNguoiDungDon[0].hoVaTen+'"') : 'này'} không?`}
                    redux={this.props.parent}
                    deleteId={this.props.item.soTiepCongDanId}
                  />
                </ShowIf>
              </div>
            ) : (
              <div className="todo-wrap two-item"></div>
            )
          }
        </td>
      </tr>
    );
  }
}

RowItemReception.defaultProps = {
  dataLoaiDonThu: []
}

let bindStateToProps = state => {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  }
}

export default connect(bindStateToProps)(RowItemReception);



// WEBPACK FOOTER //
// ./src/components/modules/reception/datatable/list/RowItemReception.jsx